import React from "react";
import { FaCarSide, FaMapMarkedAlt, FaUserCheck } from "react-icons/fa";

const ServicesOne = () => {
  return (
    <section className="services-one section-space" id="services">
      
      {/* Background */}
      <div
        className="services-one__bg"
        style={{
          backgroundImage:
            "url(assets/images/shapes/services-bg-1-1.jpg)",
        }}
      ></div>

      {/* INFO SECTION */}
      <div className="container">
        <div className="cityride-info">
          <div className="cityride-info__inner">
            
            <div
              className="cityride-info__bg"
              style={{
                backgroundImage:
                  "url(assets/images/shapes/cityride-info-bg-1-1.jpg)",
              }}
            ></div>

            <div className="cityride-info__row row">

              {/* Easy Booking */}
              <div className="col-lg-4 col-sm-6 wow fadeInUp">
                <div className="cityride-info__item">
                  <div className="cityride-info__item__icon">
                    <FaCarSide size={40} color="#ff6600" />
                  </div>
                  <h4 className="cityride-info__item__title">
                    Easy Online & <br /> Phone Booking
                  </h4>
                </div>
              </div>

              {/* 24/7 Service */}
              <div className="col-lg-4 col-sm-6 wow fadeInUp">
                <div className="cityride-info__item">
                  <div className="cityride-info__item__icon">
                    <FaMapMarkedAlt size={40} color="#ff6600" />
                  </div>
                  <h4 className="cityride-info__item__title">
                    24/7 Cab <br /> Availability
                  </h4>
                </div>
              </div>

              {/* Customer Satisfaction */}
              <div className="col-lg-4 col-sm-6 wow fadeInUp">
                <div className="cityride-info__item">
                  <div className="cityride-info__item__icon">
                    <FaUserCheck size={40} color="#ff6600" />
                  </div>
                  <h4 className="cityride-info__item__title">
                    100% Customer <br /> Satisfaction
                  </h4>
                </div>
              </div>

            </div>

            <img
              src="/images/keyword/52.jpg"
              alt="Lotus Cab Services"
              className="cityride-info__image"
            />
          </div>
        </div>
      </div>

      {/* SERVICES SECTION */}
      <div className="container">
        <div className="services-one__top">
          <div className="row gutter-y-50 align-items-center">

            <div className="col-md-8">
              <div className="sec-title">
                <div className="sec-title__top wow fadeInUp">
                  <div className="sec-title__shape"></div>
                  <h6 className="sec-title__tagline">
                    Our Cab Services
                  </h6>
                </div>

                <h3 className="sec-title__title wow fadeInUp">
                  Reliable & Affordable <br /> Lotus Cab Services
                </h3>
              </div>
            </div>

            <div className="col-md-4">
              <div className="services-one__custome-navs"></div>
            </div>

          </div>
        </div>

        <div className="row gutter-y-30">

          {/* Local Ride */}
          <div className="col-lg-4 col-md-6">
            <div className="service-card wow fadeInUp">
              <div className="service-card__image">
                <img
                  src="/images/service/1.jpg"
                  alt="Local City Ride"
                />
              </div>

              <div className="service-card__middle">
                <h3 className="service-card__title">
                  <a href="/local-ride">
                    Local City Ride
                  </a>
                </h3>
                <p className="service-card__text">
                  Comfortable and affordable rides within the city with
                  professional drivers.
                </p>
              </div>

              <div className="service-card__btn">
                <a href="/services" className="service-card__link">
                  Explore More →
                </a>
              </div>
            </div>
          </div>

          {/* Outstation */}
          <div className="col-lg-4 col-md-6">
            <div className="service-card wow fadeInUp">
              <div className="service-card__image">
                <img
                  src="/images/service/2.jpg"
                  alt="Outstation Trip"
                />
              </div>

              <div className="service-card__middle">
                <h3 className="service-card__title">
                  <a href="/outstation-trip">
                    Outstation Trip
                  </a>
                </h3>
                <p className="service-card__text">
                  Safe and reliable long-distance cab service at affordable
                  prices.
                </p>
              </div>

              <div className="service-card__btn">
                <a href="/services" className="service-card__link">
                  Explore More →
                </a>
              </div>
            </div>
          </div>

          {/* Airport Transfer */}
          <div className="col-lg-4 col-md-6">
            <div className="service-card wow fadeInUp">
              <div className="service-card__image">
                <img
                  src="/images/service/3.jpg"
                  alt="Airport Transfer"
                />
              </div>

              <div className="service-card__middle">
                <h3 className="service-card__title">
                  <a href="/services">
                    Airport Transfer
                  </a>
                </h3>
                <p className="service-card__text">
                  On-time pickup and drop service for stress-free airport
                  travel.
                </p>
              </div>

              <div className="service-card__btn">
                <a href="/services" className="service-card__link">
                  Explore More →
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className="services-one__inner-bg"></div>
    </section>
  );
};

export default ServicesOne;
